import { TermsOfUseReadModel, UserBudgetReadModel, UsersCurrentApi } from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { CurrentUserApiService } from "../ApiServices/CurrentUserApiService";
import { GenericService } from "../GenericService";

export class CurrentUserService extends GenericService<UsersCurrentApi, CurrentUserApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, UsersCurrentApi, CurrentUserApiService);
  }

  public async ensureHasBudget(): Promise<void> {
    const response: UserBudgetReadModel = await this.apiService.usersCurrentBudget();
    this.storeContext.budgetStore.setBudgetInfo(response);
  }

  public async ensureUserPermissions(): Promise<void> {
    const response = await this.apiService.usersCurrentGetPermissions();
    if (response) {
      this.storeContext.permissionStore.setUserPermissions(response);
    } else {
      this.storeContext.permissionStore.setUserPermissions();
      console.error("Failed to fetch user account permissions", response);
    }
  }

  public async requestTermsOfUse(): Promise<string | undefined> {
    const response: TermsOfUseReadModel = await this.apiService.usersCurrentGetTermsOfUse();

    if (response.hasUserApproved) {
      this.storeContext.userStore.setUserAcceptedTermsOfUseAndPrivacyPolicy(true);
    } else if (response.termsOfUsePdfBase64) {
      this.storeContext.userStore.setUserAcceptedTermsOfUseAndPrivacyPolicy(false);

      return response.termsOfUsePdfBase64;
    }
  }

  public async acceptTermsOfUse(): Promise<string> {
    throw new Error("Not implemented");
  }
}
